
<template>
    <div>
    {{ checkModal }}
    <component v-if="isAttach" :is="isAttach" :type="attachType" @remove ="attachCloseModal" @attachFile ="attachFile"></component>
    <b-modal v-model="modalShow" ref="my-modal" hide-footer title="Добавление истории">
    <div class="row">
              <div class="col-12">
                <div class="form-label mt-3 text-left photoUpload">
                  <div class="dropdown" @click.privent="attachMedia('photo')">
                    <img v-if="upPhoto" id="photoUploadLenta" class="addModal_fixImage" data-bs-toggle="dropdown" aria-expanded="false" :src="upPhoto" />
          <svg v-if="!upPhoto" id="photoUploadLenta" class="addModal_fixImage" data-bs-toggle="dropdown" aria-expanded="false" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 10C10.1046 10 11 9.10457 11 8C11 6.89543 10.1046 6 9 6C7.89543 6 7 6.89543 7 8C7 9.10457 7.89543 10 9 10Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M13 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H15C20 22 22 20 22 15V10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M18 8V2L20 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M18 2L16 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M2.66998 18.9501L7.59998 15.6401C8.38998 15.1101 9.52998 15.1701 10.24 15.7801L10.57 16.0701C11.35 16.7401 12.61 16.7401 13.39 16.0701L17.55 12.5001C18.33 11.8301 19.59 11.8301 20.37 12.5001L22 13.9001" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
      </div>
    
                 
    </div>
              </div>
    </div>
    <button class="btn btn-primary btn-block ml-auto mt-3" @click.prevent="createEpisode" type="submit">Добавить</button>

	
</b-modal>
    
    </div> 
        </template>
        
        <script>
        import Attach from '../media/Attach.vue';
        import { BModal } from 'bootstrap-vue'
        export default {
            components: { BModal, Attach },
           name: 'Story',
            data(){
            return {
                modalShow: true,
                upPhoto: null,
                isAttach: null,
                attachType: 'photo'
            }
           },
           mounted(){
           },
           methods: {
 
            createEpisode(){
            if(this.upPhoto == null || typeof(this.upPhoto) == "undefined"){ 
                return this.$bvToast.toast('Вы не загрузили фотографию', {
          title: 'Ошибка',
          variant: 'danger',
          visible: true
        })
            }
                axios.post('/api/story.create', {'photo': this.upPhoto}).then( res => {
                    this.modalShow = false
                this.$router.push({ name: 'user.profile', params: { 'uid': res.data.uid } }) //тут нужно сделать перенаправление если уже в профиле
            }).catch( error => {
                alert(error.response.data.message);
            })
            },
            attachMedia(type){
        this.attachType = type
        this.isAttach = 'Attach'
      },
      attachCloseModal(status) {
        this.isAttach = status
      },
      attachFile(files, type, name, ftype){
        this.upPhoto = files
        this.isAttach = null
      }
           },
           emits: ['remove'],
           computed: {
        checkModal() {
            if(!this.modalShow){
                this.$emit('remove', null)
            }
           
          return 
        }
      }
        }
        </script>
        
        <style scoped>
        
        </style>
        